import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setContestCategories,
  setContestTypes,
  setInitialData as setInitialDataCricket
} from '../../actions/fantasy-cricket-action-types';
import { setInitialData as setInitialDataFootball } from '../../actions/fantasy-football-action-types';
import { setInitialData as setInitialDataYesNo } from '../../actions/fantasy-yes-no-action-types';
import Constants from '../../constants';
import _ from 'lodash';
import {
  fantasyCricketContestByCategoryList,
  fantasyCricketInitialFixtureMatchList,
  fantasyCricketInitialLiveMatchList,
  fantasyCricketInitialPlayerList,
  fantasyCricketInitialResultsMatchList,
  fantasyCricketInitialTeamsList,
  fantasyCricketLeaderBoardData,
  fantasyCricketMyContestList
} from '../../constants/fantasy_cricket/fantasy_cricket_initialstate';
import {
  fantasyFootballContestListByCategory,
  fantasyFootballFixtureList,
  fantasyFootballInitialPlayerList,
  fantasyFootballLeaderBoardList,
  fantasyFootballLiveList,
  fantasyFootballMyContestList,
  fantasyFootballMyTeamsList,
  fantasyFootballResultList
} from '../../constants/fantasy_football/fantasy_football_initialState';
import { createDeepObject } from '../../utilities/helper';
import { setWalletBallance, updateUserLevel } from '../../actions/user-actions-types';
import {
  fantasyYesnoContestListByCategory,
  fantasyYesNoFixtureMatchList,
  fantasyYesNoLeaderBoard,
  fantasyYesNoLiveMatchList,
  fantasyYesNoMyAnswersList,
  fantasyYesNoMyContestList,
  fantasyYesNoMyTeamsList,
  fantasyYesNoQuestionsList,
  fantasyYesNoResultMatchList
} from '../../constants/fantays-yes-no/fantays-yes-no-initialstate';
import { allLevelsMockData } from '../../constants/milestones';
import { changeTheme } from '../../actions/setting-actions-types';
import { setMiniGamesList } from '../../actions/mini-games-action-types';

const LoadInitialData = () => {
  const dispatch = useDispatch();
  const { xpPoints: userCurrentXp = 0, teamName = '' } = useSelector((state: any) => state.user);

  useEffect(() => {
    if (!teamName) {
      initData();
    }
    updateMiniGamesList();
    setTheme();
  }, []);

  const initData = () => {
    setFantasyCricketData();
    setFantasyFootballData();
    getContestTypesData();
    setWalletBalanceData();
    setFantasyYesOrNoData();
    getContestCategoriesData();
    setUserLevel();
  };

  const setTheme = () => {
    dispatch(changeTheme('dark'));
  };

  const updateMiniGamesList = () => {
    dispatch(setMiniGamesList(Constants.MiniGames.miniGamesList));
  };
  const setUserLevel = () => {
    const idx = allLevelsMockData.findIndex((item: any) => item.xp_required >= userCurrentXp);
    const currentLevel = allLevelsMockData.find((item: any) => item.xp_required >= userCurrentXp);
    const currentUserLevel = currentLevel?.xp_required == userCurrentXp ? idx : idx - 1;
    dispatch(updateUserLevel(currentUserLevel));
    // dispatch(updateUserData({ userLevel: currentUserLevel }));
  };

  const setWalletBalanceData = () => {
    dispatch(
      setWalletBallance({
        bonusWallet: 0,
        gameWallet: 0,
        primaryWallet: 10000,
        pokerWallet: 0,
        cashbackWallet: 0
      })
    );
  };
  const setFantasyCricketData = () => {
    dispatch(
      setInitialDataCricket({
        contestFilter: createDeepObject(Constants.ContestListFilter),
        myTeamList: fantasyCricketInitialTeamsList,
        myContestList: fantasyCricketMyContestList,
        contestListByCategory: fantasyCricketContestByCategoryList,
        playerList: fantasyCricketInitialPlayerList,
        contestTypes: {},
        leaderboard: fantasyCricketLeaderBoardData,
        list: {
          fixtures: fantasyCricketInitialFixtureMatchList,
          live: fantasyCricketInitialLiveMatchList,
          result: fantasyCricketInitialResultsMatchList
        }
      })
    );
  };

  const setFantasyFootballData = () => {
    dispatch(
      setInitialDataFootball({
        contestFilter: createDeepObject(Constants.ContestListFilter),
        isAppliedFilter: false,
        myTeamList: fantasyFootballMyTeamsList,
        myContestList: fantasyFootballMyContestList,
        allContestList: [],
        contestListByCategory: fantasyFootballContestListByCategory,
        playerList: fantasyFootballInitialPlayerList,
        contestTypes: {},
        leaderboard: fantasyFootballLeaderBoardList,
        list: {
          fixtures: fantasyFootballFixtureList,
          live: fantasyFootballLiveList,
          result: fantasyFootballResultList
        }
      })
    );
  };
  const setFantasyYesOrNoData = () => {
    dispatch(
      setInitialDataYesNo({
        contestFilter: createDeepObject(Constants.ContestListFilter),
        isAppliedFilter: false,
        list: {
          fixtures: fantasyYesNoFixtureMatchList,
          live: fantasyYesNoLiveMatchList,
          result: fantasyYesNoResultMatchList
        },
        questionsList: fantasyYesNoQuestionsList,
        contestCategories: fantasyYesnoContestListByCategory,
        myContestList: fantasyYesNoMyContestList,
        myAnswersList: fantasyYesNoMyAnswersList,
        leaderboard: fantasyYesNoLeaderBoard,
        myTeamList: fantasyYesNoMyTeamsList
      })
    );
  };

  const getContestTypesData = () => {
    let contestTypes: any = {};
    let contestTypeListById: any = _.groupBy(Constants.ContestTypes, function (category) {
      return category.id;
    });
    for (let key in contestTypeListById) {
      // eslint-disable-next-line no-prototype-builtins
      if (contestTypeListById.hasOwnProperty(key)) {
        contestTypes[key] = contestTypeListById[key][0];
      }
    }
    dispatch(setContestTypes(contestTypes));
  };

  const getContestCategoriesData = () => {
    let contestCategories: any = {};
    let contestCategoryListById = _.groupBy(Constants.ContestCategories, function (category) {
      return category.id;
    });
    for (let key in contestCategoryListById) {
      // eslint-disable-next-line no-prototype-builtins
      if (contestCategoryListById.hasOwnProperty(key)) {
        contestCategories[key] = contestCategoryListById[key][0];
      }
    }
    dispatch(setContestCategories(contestCategories));
  };
  return null;
};
export default React.memo(LoadInitialData);
